interface IconProps {
    animate?: boolean;
}

export function CelebrateIcon({ animate = false }: IconProps) {
    return (
        <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Celebrate">
            <style>
                {`
                    @keyframes cc-celebrate-particle {
                        0% {
                            transform: translate(0, 0) rotate(0deg);
                            opacity: 1;
                        }
                        100% {
                            transform: translate(var(--tx, 0), var(--ty, 0)) rotate(var(--r, 0deg));
                            opacity: 0;
                        }
                    }

                    @keyframes cc-celebrate-cone {
                        0%, 80% {
                            transform: rotate(0deg);
                        }
                        85% {
                            transform: rotate(-8deg);
                        }
                        90% {
                            transform: rotate(8deg);
                        }
                        95% {
                            transform: rotate(-4deg);
                        }
                        100% {
                            transform: rotate(0deg);
                        }
                    }

                    .cc-cb-p-animated {
                        animation: cc-celebrate-particle 0.6s ease-out forwards;
                        animation-delay: var(--d, 0s);
                    }

                    .cc-cb-cone-animated {
                        transform-origin: 27px 44px;
                        animation: cc-celebrate-cone 0.6s ease-in-out forwards;
                    }

                    @media (prefers-reduced-motion: reduce) {
                        .cc-cb-p-animated,
                        .cc-cb-cone-animated {
                            animation: none;
                        }
                    }
                `}
            </style>
            <rect x="2" y="2" width="60" height="60" rx="19" fill="#FFAB00" />
            <g className={animate ? 'cc-cb-cone-animated' : ''}>
                <path d="M16 50 L28 27 39 38z" fill="#493193" />
                <path d="M22.5 37.5 L34 32.5 30.5 29z" fill="#7C5FC9" opacity=".9" />
                <path d="M18.6 45 L36 37 33 34z" fill="#FFFFFF" opacity=".55" />
            </g>
            <g style={{ '--tx': '9px', '--ty': '-15px', '--r': '200deg' } as import('react').CSSProperties}>
                <rect className={animate ? 'cc-cb-p-animated' : ''} x="33" y="26" width="5" height="3" rx="1" fill="#FFFFFF" />
            </g>
            <g style={{ '--tx': '14px', '--ty': '-6px', '--r': '160deg', '--d': '.06s' } as import('react').CSSProperties}>
                <rect className={animate ? 'cc-cb-p-animated' : ''} x="36" y="31" width="4.5" height="3" rx="1" fill="#2F1F61" />
            </g>
            <g style={{ '--tx': '3px', '--ty': '-19px', '--r': '120deg', '--d': '.1s' } as import('react').CSSProperties}>
                <circle className={animate ? 'cc-cb-p-animated' : ''} cx="32" cy="23" r="2.2" fill="#7DD7EF" />
            </g>
            <g style={{ '--tx': '16px', '--ty': '-13px', '--r': '240deg', '--d': '.14s' } as import('react').CSSProperties}>
                <rect className={animate ? 'cc-cb-p-animated' : ''} x="38" y="25" width="4" height="4" rx="1.2" fill="#E8DFF5" />
            </g>
            <g style={{ '--tx': '7px', '--ty': '-9px', '--d': '.18s' } as import('react').CSSProperties}>
                <circle className={animate ? 'cc-cb-p-animated' : ''} cx="40" cy="20" r="1.8" fill="#FF5630" />
            </g>
            <g style={{ '--tx': '12px', '--ty': '-20px', '--r': '300deg', '--d': '.22s' } as import('react').CSSProperties}>
                <rect className={animate ? 'cc-cb-p-animated' : ''} x="35" y="18" width="3.6" height="3.6" rx="1" fill="#493193" />
            </g>
        </svg>
    );
}
